import script from "./InstallInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallInvite.vue?vue&type=script&setup=true&lang=js"

import "./InstallInvite.vue?vue&type=style&index=0&id=8442c3d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8442c3d6"]])

export default __exports__